import { type FC, type ReactNode } from 'react';

interface MobileMoreMenuProps {
  open: boolean;
  onClose: () => void;
  onAutoLayout: () => void;
  onExport: () => void;
  onHistory: () => void;
}

export const MobileMoreMenu: FC<MobileMoreMenuProps> = ({
  open,
  onClose,
  onAutoLayout,
  onExport,
  onHistory,
}) => {
  if (!open) return null;

  const Row = ({
    icon,
    label,
    onClick,
    destructive,
  }: {
    icon: string;
    label: string;
    onClick: () => void;
    destructive?: boolean;
  }): ReactNode => (
    <button
      onClick={() => {
        onClick();
        onClose();
      }}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 14,
        width: '100%',
        padding: '14px 16px',
        backgroundColor: 'transparent',
        border: 'none',
        borderBottom: '1px solid var(--color-border)',
        textAlign: 'left',
        color: destructive ? '#EF4444' : 'var(--color-text)',
        fontSize: 15,
        fontWeight: 500,
      }}
    >
      <span style={{ fontSize: 20, width: 24, textAlign: 'center' }}>{icon}</span>
      {label}
    </button>
  );

  return (
    <>
      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          inset: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          zIndex: 900,
        }}
      />
      <div
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'var(--color-surface)',
          borderRadius: '20px 20px 0 0',
          boxShadow: '0 -10px 40px rgba(0,0,0,0.4)',
          zIndex: 910,
          paddingBottom: 'env(safe-area-inset-bottom, 0)',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'center', padding: '8px 0 4px' }}>
          <div style={{ width: 40, height: 4, borderRadius: 2, backgroundColor: 'var(--color-border)' }} />
        </div>
        <div style={{ padding: '8px 0' }}>
          <Row icon="⇅" label="Réorganiser automatiquement" onClick={onAutoLayout} />
          <Row icon="📤" label="Exporter (PNG / PDF / JSON)" onClick={onExport} />
          <Row icon="⏱" label="Historique" onClick={onHistory} />
        </div>
      </div>
    </>
  );
};

export default MobileMoreMenu;
